module.exports = __webpack_public_path__ + "static/media/checkbox_checked.3c00d6c7.svg";